import { BookingDataModel, DepartmentDataModel, LocationDataModel, DoctorDataModel, Bookingkeyvaluepair, keyvaluepair, SlotBookingModel} from "../../Model/index";

export class BookingDataContainer {
    BookingList: BookingDataModel[] = [];
    Departments: DepartmentDataModel[] = [];
    Locations: LocationDataModel[] = [];
    Doctors: DoctorDataModel[] = []
    totalTimeSlots: SlotBookingModel[] = [];
    totalTimeSlotsBooking: keyvaluepair[] = [];
    sessionExpiry: boolean;
    BookingType: string;
    DefaultDept: string;
    IsGuestPatientEmailReq: string;
    PaymentType: string;
    IsSearch: string;
    SessionTimeout: string;
	PaymentGatewayType : string;
	PaymentLaterStatus : string;
	PatientSex : string;
    PatientAge: number;
    DefaultCPRNOLength: string;
    DefaultBackVisible: string;
    GuestNewPatientReq: string;
    ISSelfPayOption: string;
    ISReqDocOption: string;
    PortalDesc: string;
    ISDocDepartOption: string;
    IsProceedPayNow: string;
    DefaultLocation: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/booking/bookingdatacontainer.ts